import { t, Instance } from 'mobx-state-tree';

/**
 * Manages the children of the root generation
 */
export const ChildrenGenerationModel = t
  .model('ChildrenGeneration', {
    childrenFamilyMemberIds: t.optional(t.array(t.string), [])
  })
  .actions((self) => ({
    setChildrenFamilyMemberIds(childrenFamilyMemberIds: string[]) {
      self.childrenFamilyMemberIds.replace(childrenFamilyMemberIds);
    },
    clear() {
      self.childrenFamilyMemberIds.replace([]);
    }
  }));

export type ChildrenGenerationType = Instance<typeof ChildrenGenerationModel>;
